<template>
  <v-chip
    v-if="value"
    :disabled="disable"
    x-small
    :color=color
    @click="chip_clicked"
  >
    <v-icon small v-if="!item.hide_icon">{{ icon }}</v-icon>
    <span style="text-transform: capitalize;" v-if="!item.hide_text"> {{ text + " :" }}</span>
    <span>{{ value }} </span>
  </v-chip>
</template>

<script>

  export default {
    name: 'GenericChip',

    props: {
      item: {type: Object},
      disable: {
       type: Boolean,
       default: false,
     },
    },

    computed: {
      text() {
        return this.item.readable || this.item.name || this.$vuetify.lang.translator('chips.value');
      },
      value() {
        return this.item.readableValue || this.item.value;
      },
      color() {
        return this.item.color || "";
      },
      icon() {
        return this.item.icon || 'mdi-check';
      }
    },

    methods: {
      chip_clicked(){
        this.$emit('update',this.item);
      },
    },
  }
</script>
